import React from "react";

export default function LoaderFab() {
    return (
        <>
            <figure>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </figure>
        </>
    )
}
